import { useEffect, useState } from "react"
import classNames from "classnames"

export default function ImageLoader(props) {

    const {
        src, onLoad, onError,
        containerClassName, imgClassName, loadingClassName,
        duration = 700,
        ...imgProps
    } = props
    const [ imgLoaded, setImgLoaded ] = useState(null)

    useEffect(() => {
        const img = new Image()
        img.addEventListener('load', handleOnLoad, false)
        img.addEventListener('error', handleOnError, false)
        img.src = src

        return () => {
            img.removeEventListener('load', handleOnLoad, false)
            img.removeEventListener('error', handleOnError, false)
        }
    }, [])


    const handleOnLoad = () => {
        // console.log('img onLoad', src)
        setImgLoaded(true)
        onLoad && onLoad()
    }
    const handleOnError = (err) => {
        console.log('img onError', 'src', src, err)
        setImgLoaded(false)
        onError && onError()
    }

    return (
        <div className={classNames('relative full shrink-0', containerClassName)}>
            <img
                src={src}
                className={classNames('full object-cover transition', imgClassName, {
                    'opacity-[1]': imgLoaded,
                    'opacity-[0]': !imgLoaded
                })}
                style={{
                    transitionDuration: `${duration}ms`
                }}
                {...imgProps}
            />
            <div
                className={classNames('absolute top-0 full transition pointer-events-none', {
                    'opacity-[0]': imgLoaded,
                    'opacity-[1]': !imgLoaded
                })}
                style={{
                    transitionDuration: `${duration}ms`
                }}
            >
                <div className={classNames('full bg-gray-600 animate-dim', loadingClassName)}></div>
            </div>
        </div>
    )
}